<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">请假/休假审批申请表</h2>
    </div>
    <div class="form-content">
      <el-col :span="24">
        <el-form ref="form" :model="form" label-width="80px" class="form">
          <create-vacation-approval
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          ></create-vacation-approval>

          <!-- <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments"
                :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>-->

          <div class="tip" style="margin:20px 0 0 40px">* 意见与审批</div>
          <div >
            <p>
              <a
                href="javascript:;"
                style="color:#d93c37;text-decoration: underline;"
                @click="showApprovalUserStatus=true"
              >不清楚如何选择审批人? 点击查看帮助</a>
            </p>
          </div>
          <div class="clear label-mx">
            <!-- <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>-->

            <!-- 审批 -->
            <!-- <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
            :approvalSetDep="approvalSetDep"></approval-item-by-custom>-->

            <approval-item
              ref="approval"
              :approvalUsers="approvalUsers.c101"
              :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"
            ></approval-item>
          </div>

          <!-- <el-form-item label=""> -->
          <div class="form-btn-room">
            <el-button
              style="width:100%;"
              :loading="formLoading"
              @click="createProject()"
              class="form-btn"
              type="success"
            >
              确认提交请假 /
              休假审批申请表
            </el-button>
          </div>
          <!-- </el-form-item> -->
        </el-form>
      </el-col>
    </div>

    <!-- 审批人说明弹窗 -->
    <div class="pop-room pop-vacation-img-info" v-if="showApprovalUserStatus">
      <h3 class="title">审批领导选择说明</h3>
      <a href="javascript:;" @click="showApprovalUserStatus=false" class="iconfont icon-close"></a>
      <div class="">
        <!-- 说明图片 -->
        <img v-if="this.form.depId==7" src="/static/images/vacation_jt.png" width="100%" alt />
        <img v-else src="/static/images/vacation_zgs.png" width="100%" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";

import approvalUsers from "@/Mixins/approvalUsers";
import ApprovalItem from "@/components/ApprovalItem";
// import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

import createVacationApproval from "@/page/form/personnel/createVacationApproval_m";
export default {
  components: {
    // ApprovalItemByCustom,
    createVacationApproval,
    Attachments,
    ApprovalItem
  },
  mixins: [approvalUsers],
  computed: {
    ...mapState({
      userData: state => state.main.userData
    })
  },
  data() {
    return {
      hasApplyId: "",
      contractType: 1,

      project: {},
      form: {
        title: "",
        // 约定成加入公司时间
        applyTime: "",
        startTime: "",
        endTime: "",
        totalTime: "",
        type: "",
        content: "",
        depId: "",
        json: true
      },
      // approvalUsersData: "",

      // 审批
      approvalType: "0",
      formLoading: false,

      applyInfo: "",
      attachmentArr: [],

      defaultApprovalUsers: "",
      selectArr: [],
      approvalSetDep: {},

      showApprovalUserStatus: false
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.applyId) {
      this.form.applyId = this.$route.query.applyId / 1;
    }

    this.getApplyData();
  },
  methods: {
    // 获取审批表原内容
    getApplyData() {
      this.hasApplyId = this.form.applyId ? true : false;
      if (this.form.applyId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
      } else {
        this.setSelectArr(this.applyInfo, 101);
      }
    },
    // 获取原审批表内容
    getProjectApplyInfo() {
      ajax.get("/human/leave/apply/info/" + this.form.applyId, "", res => {
        this.applyInfo = this.form = res.vo;

        this.form.applyId = this.form.flow.applyId;
        this.form.json = true;
        if (this.form.startTime && this.form.endTime) {
          this.form.time = [this.form.startTime, this.form.endTime];
        }
        this.form.depId = this.form.department.id;

        this.attachmentArr = this.form.attachments ? this.form.attachments : [];
        // this.selectArr = this.form.flow.approvals.map(item => item.user)

        this.setSelectArr(this.applyInfo, 101);
        this.formLoading = false;
      });
    },
    // 提交申请
    createProject() {
      this.form = this.$refs.create.getFromData();

      if (!this.form.content) {
        this.$message.error("请假/休假审批必须填写审批原因");
        return;
      }
      if (!this.form.startTime || !this.form.endTime) {
        this.$message.error("请假/休假审批必须选择请假时间范围");
        return;
      }
      if (!this.form.totalTime) {
        this.$message.error("请假/休假审批必须填写请假天数");
        return;
      }

      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      this.form.attachments = ""

      console.log(this.form.approvalUserIds);
      // return

      this.formLoading = true;
      let _url = !this.form.applyId
        ? "/human/leave/apply"
        : "/human/leave/apply/edit?applyId=" + this.form.applyId;

      ajax.post(
        _url,
        this.form,
        res => {
          this.$message.success("提交审批成功，请耐心等待领导审批");
          this.$router.push("/Personnel/Vacation/List");
          this.formLoading = false;
        },
        res => {
          this.formLoading = false;
        }
      );
    }
  },
  watch: {}
};
</script>


// WEBPACK FOOTER //
// src/page/m/vacation/info.vue